<template>
  <div :class="mergedClasses" v-on="$listeners">
    <component
      v-if="iconComponent"
      :is="iconComponent"
      class="fe-w-full fe-h-full"
      :style="{ cursor: 'inherit' }"
    />
    <!-- The reason for which we defined "cursor: inherit" is that because in jiomart, some widget is overriding the svg css.
     Because of which, in disabled button which has icon, cursor is changing on hovering the mouse -->
  </div>
</template>

<script>
  import icons from "@/assets/icons/icons"
  import { classMerge } from "@/utils/utils"

  export default {
    name: "JdsIcon",
    props: {
      name: {
        type: String,
        required: true,
        default: "",
      },
      size: {
        type: String,
        default: "m",
        validator(value) {
          return ["s", "m", "l", "xl", "xxl"].includes(value)
        },
      },
      smSize: {
        type: String,
        default: "",
        validator(value) {
          return ["s", "m", "l", "xl", "xxl"].includes(value)
        },
      },
      lgSize: {
        type: String,
        default: "",
        validator(value) {
          return ["s", "m", "l", "xl", "xxl"].includes(value)
        },
      },
      color: {
        type: String,
        default: "fe-text-primary-50",
      },
      bgColor: {
        type: String,
        default: "",
      },
      inverse: {
        type: Boolean,
        default: false,
      },
      className: {
        type: String,
        default: "",
      },
    },
    inheritAttrs: false, // This prevents the component from automatically inheriting attributes to the root element, giving us full control over attribute binding.
    computed: {
      iconComponent() {
        return icons[this.name] || null
      },
      baseClasses() {
        return "fe-inline-flex fe-justify-center fe-items-center"
      },
      sizeClass() {
        const sizeMap = {
          s: "fe-w-base fe-h-base",
          m: "fe-w-m fe-h-m",
          l: "fe-w-l fe-h-l",
          xl: "fe-w-xl fe-h-xl",
          xxl: "fe-w-xxl fe-h-xxl",
        }
        return sizeMap[this.size] || sizeMap.m
      },
      smSizeClass() {
        const sizeMap = {
          s: "sm:fe-w-base sm:fe-h-base",
          m: "sm:fe-w-m sm:fe-h-m",
          l: "sm:fe-w-l sm:fe-h-l",
          xl: "sm:fe-w-xl sm:fe-h-xl",
          xxl: "sm:fe-w-xxl sm:fe-h-xxl",
        }
        return sizeMap[this.smSize] || ""
      },
      lgSizeClass() {
        const sizeMap = {
          s: "lg:fe-w-base lg:fe-h-base",
          m: "lg:fe-w-m lg:fe-h-m",
          l: "lg:fe-w-l lg:fe-h-l",
          xl: "lg:fe-w-xl lg:fe-h-xl",
          xxl: "lg:fe-w-xxl lg:fe-h-xxl",
        }
        return sizeMap[this.lgSize] || ""
      },
      colorClass() {
        return this.inverse ? "fe-text-white" : this.color
      },
      bgClass() {
        // Rounded class needs to be added when background color is provided. And also adding padding to have the space between icon and icon edges
        const roundedClass = "fe-rounded-[500px] fe-p-xxs"
        return this.bgColor ? `${this.bgColor} ${roundedClass}` : ""
      },
      mergedClasses() {
        return classMerge(
          this.baseClasses,
          this.sizeClass,
          this.smSizeClass,
          this.lgSizeClass,
          this.colorClass,
          this.bgClass,
          this.className,
        )
      },
    },
  }
</script>
